import React, { Component } from 'react';
import styled from 'styled-components';

export const StyledRow = styled.div`
  > div { width: 100%; }

  &.twoCol {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
    > *:first-of-type {
      margin-bottom: 15px;
    }

    > div {
      width: 100%;
    }

    > section {
      width: 100%;
    }

    @media screen and (min-width: 600px) {
      > *:first-of-type {
        margin-bottom: 0px;
      }
      > div {
        width: 48%;
      }
      > section {
        width: 49%;
      }
    }
  }
`

class Row extends Component {
  render() {
    return (
      <StyledRow style={this.props.style} className={this.props.className}>
        {this.props.children}
      </StyledRow>
    )
  }
}

export default Row